'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
type CarouselProps = {
  children: React.ReactNode;
  slidesPerView?: {
    mobile: number;
    desktop: number;
  };
  gap?: number;
  showDots?: boolean;
  showArrows?: boolean;
};
export default function Carousel(t0) {
  const $ = _c(53);
  const {
    children,
    slidesPerView: t1,
    gap: t2,
    showDots: t3,
    showArrows: t4
  } = t0;
  let t5;
  if ($[0] !== t1) {
    t5 = t1 === undefined ? {
      mobile: 1,
      desktop: 2
    } : t1;
    $[0] = t1;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const slidesPerView = t5;
  const gap = t2 === undefined ? 32 : t2;
  const showDots = t3 === undefined ? true : t3;
  const showArrows = t4 === undefined ? false : t4;
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      loop: true,
      align: "start",
      slidesToScroll: 1,
      containScroll: "trimSnaps"
    };
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t6);
  const [selectedIndex, setSelectedIndex] = useState(0);
  let t7;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = [];
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const [scrollSnaps, setScrollSnaps] = useState(t7);
  const [isDesktop, setIsDesktop] = useState(false);
  let t8;
  let t9;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      const handleResize = () => {
        setIsDesktop(window.innerWidth >= 1440);
      };
      handleResize();
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    };
    t9 = [];
    $[4] = t8;
    $[5] = t9;
  } else {
    t8 = $[4];
    t9 = $[5];
  }
  useEffect(t8, t9);
  let t10;
  if ($[6] !== emblaApi) {
    t10 = () => {
      if (emblaApi) {
        emblaApi.reInit();
      }
    };
    $[6] = emblaApi;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  let t11;
  if ($[8] !== emblaApi || $[9] !== isDesktop) {
    t11 = [emblaApi, isDesktop];
    $[8] = emblaApi;
    $[9] = isDesktop;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  useEffect(t10, t11);
  let t12;
  if ($[11] !== emblaApi) {
    t12 = index => emblaApi?.scrollTo(index);
    $[11] = emblaApi;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  const scrollTo = t12;
  let t13;
  if ($[13] !== emblaApi) {
    t13 = () => emblaApi?.scrollPrev();
    $[13] = emblaApi;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  const scrollPrev = t13;
  let t14;
  if ($[15] !== emblaApi) {
    t14 = () => emblaApi?.scrollNext();
    $[15] = emblaApi;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  const scrollNext = t14;
  let t15;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = emblaApi_0 => {
      setScrollSnaps(emblaApi_0.scrollSnapList());
    };
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  const onInit = t15;
  let t16;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = emblaApi_1 => {
      setSelectedIndex(emblaApi_1.selectedScrollSnap());
    };
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  const onSelect = t16;
  let t17;
  let t18;
  if ($[19] !== emblaApi) {
    t17 = () => {
      if (!emblaApi) {
        return;
      }
      emblaApi.on("reInit", onInit).on("select", onSelect);
      const frameId = requestAnimationFrame(() => {
        onInit(emblaApi);
        onSelect(emblaApi);
      });
      return () => {
        cancelAnimationFrame(frameId);
        emblaApi.off("reInit", onInit).off("select", onSelect);
      };
    };
    t18 = [emblaApi, onInit, onSelect];
    $[19] = emblaApi;
    $[20] = t17;
    $[21] = t18;
  } else {
    t17 = $[20];
    t18 = $[21];
  }
  useEffect(t17, t18);
  const slidesVisible = isDesktop ? slidesPerView.desktop : slidesPerView.mobile;
  const slideWidth = `calc(${100 / slidesVisible}% - ${gap * (slidesVisible - 1) / slidesVisible}px)`;
  let t19;
  if ($[22] !== children) {
    t19 = Array.isArray(children) ? children : [children];
    $[22] = children;
    $[23] = t19;
  } else {
    t19 = $[23];
  }
  const slides = t19;
  const t20 = `-${gap / 2}px`;
  const t21 = `-${gap / 2}px`;
  let t22;
  if ($[24] !== t20 || $[25] !== t21) {
    t22 = {
      marginLeft: t20,
      marginRight: t21
    };
    $[24] = t20;
    $[25] = t21;
    $[26] = t22;
  } else {
    t22 = $[26];
  }
  let t23;
  if ($[27] !== gap || $[28] !== slideWidth || $[29] !== slides) {
    let t24;
    if ($[31] !== gap || $[32] !== slideWidth) {
      t24 = (child, index_0) => <div key={index_0} className="flex-[0_0_auto]" style={{
        width: slideWidth,
        paddingLeft: `${gap / 2}px`,
        paddingRight: `${gap / 2}px`
      }}>{child}</div>;
      $[31] = gap;
      $[32] = slideWidth;
      $[33] = t24;
    } else {
      t24 = $[33];
    }
    t23 = slides.map(t24);
    $[27] = gap;
    $[28] = slideWidth;
    $[29] = slides;
    $[30] = t23;
  } else {
    t23 = $[30];
  }
  let t24;
  if ($[34] !== t22 || $[35] !== t23) {
    t24 = <div className="flex" style={t22}>{t23}</div>;
    $[34] = t22;
    $[35] = t23;
    $[36] = t24;
  } else {
    t24 = $[36];
  }
  let t25;
  if ($[37] !== emblaRef || $[38] !== t24) {
    t25 = <div className="overflow-hidden" ref={emblaRef}>{t24}</div>;
    $[37] = emblaRef;
    $[38] = t24;
    $[39] = t25;
  } else {
    t25 = $[39];
  }
  let t26;
  if ($[40] !== scrollNext || $[41] !== scrollPrev || $[42] !== showArrows) {
    t26 = showArrows && <><button className="bg-black/50 hover:bg-black/70 absolute top-1/2 left-[8px] z-10 -translate-y-1/2 rounded-full p-2 transition-opacity" onClick={scrollPrev} aria-label="Previous slide"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-FFFFFF"><path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg></button><button className="bg-black/50 hover:bg-black/70 absolute top-1/2 right-[8px] z-10 -translate-y-1/2 rounded-full p-2 transition-opacity" onClick={scrollNext} aria-label="Next slide"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-FFFFFF"><path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg></button></>;
    $[40] = scrollNext;
    $[41] = scrollPrev;
    $[42] = showArrows;
    $[43] = t26;
  } else {
    t26 = $[43];
  }
  let t27;
  if ($[44] !== scrollSnaps || $[45] !== scrollTo || $[46] !== selectedIndex || $[47] !== showDots) {
    t27 = showDots && <div className="mt-[32px] flex justify-center gap-[8px]">{scrollSnaps.map((_, index_1) => <button key={index_1} className={`h-[10px] w-[10px] rounded-full transition-all ${index_1 === selectedIndex ? "bg-[#27D3ED]" : "bg-[#1a2d4d] hover:bg-[#0C4A98]"}`} onClick={() => scrollTo(index_1)} aria-label={`Go to slide ${index_1 + 1}`} />)}</div>;
    $[44] = scrollSnaps;
    $[45] = scrollTo;
    $[46] = selectedIndex;
    $[47] = showDots;
    $[48] = t27;
  } else {
    t27 = $[48];
  }
  let t28;
  if ($[49] !== t25 || $[50] !== t26 || $[51] !== t27) {
    t28 = <div className="relative">{t25}{t26}{t27}</div>;
    $[49] = t25;
    $[50] = t26;
    $[51] = t27;
    $[52] = t28;
  } else {
    t28 = $[52];
  }
  return t28;
}